package com.evoapps.evoshift.data.dto.team

import kotlinx.serialization.Serializable

/**
 * workplaces/{wpId}/announcements/{id} as read (SH-118). The server adds `recipientCount` and the
 * TTL's `expireAt` (not read here).
 */
@Serializable
data class AnnouncementDto(
    val id: String = "",
    val workplaceId: String = "",
    val authorId: String = "",
    val authorName: String? = null,
    val text: String = "",
    val pinned: Boolean = false,
    val targetRole: String? = null,
    val createdAt: String = "",
    val recipientCount: Int? = null
)

/** A new post, exactly the fields firestore.rules (validAnnouncement) accept from the app. */
@Serializable
data class NewAnnouncementDto(
    val id: String,
    val workplaceId: String,
    val authorId: String,
    val authorName: String,
    val text: String,
    val pinned: Boolean,
    val targetRole: String?,
    val createdAt: String
)

/** …/announcements/{id}/reads/{uid}: the read receipt. */
@Serializable
data class AnnouncementReadDto(val userId: String = "", val readAt: String = "")

/** workplaces/{wpId}/shift_notes/{shiftId} (SH-118); the server adds `expireAt`. */
@Serializable
data class ShiftNoteDto(
    val shiftId: String = "",
    val userId: String = "",
    val note: String = "",
    val updatedAt: String = "",
    val updatedBy: String = ""
)
